import { searchReportingFetch } from '../lib/flags/search-reporting';
import { getAuthToken } from './auth';
import { notificationsClient } from '../lib/trpc/notifications-main';

// Reads use OpenSearch (fast indexed queries); writes use the notification API (source of truth).
// This is intentional — OpenSearch syncs from the notification API with eventual consistency.
// After a mutation, we update local state optimistically so the UI reflects changes immediately.
const OPENSEARCH_URL = import.meta.env.VITE_APP_OPENSEARCH_URL;

export interface NotificationRecord {
  id: string;
  actionType: string;
  entityType: string;
  status: string;
  actionLabel: string;
  userEmail?: string;
  clerkUserID?: string;
  isRead: boolean;
  createdAt: number;
  metadata?: Record<string, any>;
}

export async function listNotifications(): Promise<NotificationRecord[]> {
  const response = await searchReportingFetch(`${OPENSEARCH_URL}/notifications`, {
    method: 'GET',
    headers: {
      Authorization: await getAuthToken(),
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to list notifications: ${response.status}`);
  }

  const data = await response.json();
  return data.notifications || [];
}

export async function deleteNotification(id: string): Promise<void> {
  const response = await notificationsClient.deleteNotification(id, await getAuthToken());

  if (!response.ok) {
    throw new Error(`Failed to delete notification: ${response.status}`);
  }
}

export async function markNotificationRead(id: string): Promise<void> {
  const response = await notificationsClient.markNotificationRead(id, await getAuthToken());

  if (!response.ok) {
    throw new Error(`Failed to mark notification read: ${response.status}`);
  }
}

export async function markAllNotificationsRead(): Promise<void> {
  const response = await notificationsClient.markAllNotificationsRead(await getAuthToken());

  if (!response.ok) {
    throw new Error(`Failed to mark all notifications read: ${response.status}`);
  }
}
